import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/common/PageLayout';

const Campaigns = () => (
  <PageLayout>
    <section className="page-hero">
      <h1>Campaigns</h1>
      <p>Time-bound learning initiatives and partnerships to drive skills at scale.</p>
    </section>
    <section className="page-section">
      <h2>Current & Upcoming</h2>
      <p>We run campaigns with enterprises, colleges, and communities to make skill-building accessible and measurable.</p>
      <div className="page-section-grid">
        <div className="page-card">
          <h3>Enterprise drives</h3>
          <p>Upskilling campaigns for large teams and departments.</p>
        </div>
        <div className="page-card">
          <h3>Campus programs</h3>
          <p>College-wide challenges and certification batches.</p>
        </div>
        <div className="page-card">
          <h3>Community initiatives</h3>
          <p>Open campaigns for learners and educators.</p>
        </div>
      </div>
    </section>
   
  </PageLayout>
);

export default Campaigns;
